module.exports = __webpack_public_path__ + "img/yacht-1.e7bedcf7.jpg";